import { Loading } from "~/components/reusable/Loading"
import { cn } from "~/utils/helpers"

/**
 * The one loading treatment in the demand area, centred in its slot. Not `LoadingOverlay`: same
 * spinner, but `sm` by default and without the rotating-message machinery.
 */
export const SizingSpinner = ({
  size = "sm",
  className,
}: {
  size?: "sm" | "base"
  className?: string
}) => (
  <div className={cn("flex items-center justify-center", className)} role="status">
    <Loading size={size} className="text-fg-subtle" />
    <span className="sr-only">Loading</span>
  </div>
)
